import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Shared hook for loading employees + departments from backend.
 * Used by all form modals and settings pages.
 */
export default function useDirectory() {
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const [empRes, deptRes] = await Promise.all([
        axios.get(`${API}/employees`),
        axios.get(`${API}/departments`),
      ]);
      setEmployees(empRes.data || []);
      setDepartments(deptRes.data || []);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const employeeNames = employees.map((e) => e.name);
  const departmentNames = departments.map((d) => d.name);

  return { employees, departments, employeeNames, departmentNames, loading, error, reload };
}
